module.exports = __webpack_public_path__ + "static/assets/f3c58022ba99d35e7c35fd2af68dcade.ttf";